module.exports.default = [
    {
        "name": "Basque",
        "code": "eu",
        "translations": 54,
        "percentage": 34.39,
        "updated": "2021-11-09T07:22:35+0000"
    },
    {
        "name": "Bulgarian",
        "code": "bg",
        "translations": 26,
        "percentage": 16.56,
        "updated": "2020-06-04T07:40:46+0000"
    },
    {
        "name": "Catalan",
        "code": "ca",
        "translations": 54,
        "percentage": 34.39,
        "updated": "2021-11-09T07:22:46+0000"
    },
    {
        "name": "Danish",
        "code": "da",
        "translations": 26,
        "percentage": 16.56,
        "updated": "2020-06-04T07:41:35+0000"
    },
    {
        "name": "Dutch",
        "code": "nl",
        "translations": 105,
        "percentage": 66.88,
        "updated": "2021-05-23T09:52:47+0000"
    },
    {
        "name": "English",
        "code": "en",
        "translations": 157,
        "percentage": 100,
        "updated": "2024-07-16T13:33:00+0000"
    },
    {
        "name": "Finnish",
        "code": "fi",
        "translations": 45,
        "percentage": 28.66,
        "updated": "2024-10-01T13:26:02+0000"
    },
    {
        "name": "French",
        "code": "fr",
        "translations": 137,
        "percentage": 87.26,
        "updated": "2024-11-11T09:52:38+0000"
    },
    {
        "name": "Galician",
        "code": "gl",
        "translations": 54,
        "percentage": 34.39,
        "updated": "2021-11-09T07:23:00+0000"
    },
    {
        "name": "German",
        "code": "de",
        "translations": 81,
        "percentage": 51.59,
        "updated": "2024-10-01T13:26:15+0000"
    },
    {
        "name": "Greek",
        "code": "el",
        "translations": 30,
        "percentage": 19.11,
        "updated": "2022-11-08T10:13:19+0000"
    },
    {
        "name": "Hebrew",
        "code": "he",
        "translations": 86,
        "percentage": 54.78,
        "updated": "2024-10-01T13:26:22+0000"
    },
    {
        "name": "Italian",
        "code": "it",
        "translations": 84,
        "percentage": 53.5,
        "updated": "2024-10-01T13:26:30+0000"
    },
    {
        "name": "Kinyarwanda",
        "code": "rw",
        "translations": 148,
        "percentage": 94.27,
        "updated": "2024-03-18T13:50:42+0000"
    },
    {
        "name": "Polish",
        "code": "pl",
        "translations": 27,
        "percentage": 17.2,
        "updated": "2024-03-18T13:51:33+0000"
    },
    {
        "name": "Portuguese",
        "code": "pt",
        "translations": 157,
        "percentage": 100,
        "updated": "2024-10-01T13:26:32+0000"
    },
    {
        "name": "Portuguese (BR)",
        "code": "pt-br",
        "translations": 157,
        "percentage": 100,
        "updated": "2024-10-01T13:26:38+0000"
    },
    {
        "name": "Romanian",
        "code": "ro",
        "translations": 26,
        "percentage": 16.56,
        "updated": "2020-06-04T07:56:28+0000"
    },
    {
        "name": "Russian",
        "code": "ru",
        "translations": 26,
        "percentage": 16.56,
        "updated": "2020-06-04T07:57:17+0000"
    },
    {
        "name": "Spanish",
        "code": "es",
        "translations": 157,
        "percentage": 100,
        "updated": "2024-10-01T13:26:43+0000"
    },
    {
        "name": "Swedish",
        "code": "sv",
        "translations": 27,
        "percentage": 17.2,
        "updated": "2020-06-04T07:43:55+0000"
    },
    {
        "name": "Thai",
        "code": "th",
        "translations": 26,
        "percentage": 16.56,
        "updated": "2020-06-04T07:57:53+0000"
    },
    {
        "name": "Turkish",
        "code": "tr",
        "translations": 27,
        "percentage": 17.2,
        "updated": "2020-06-04T07:23:37+0000"
    },
    {
        "name": "Vietnamese",
        "code": "vi",
        "translations": 26,
        "percentage": 16.56,
        "updated": "2020-06-04T07:54:35+0000"
    }
];
	